export default class Modal {
    constructor() {
        this.html = document.querySelector('html');
        this.modal = document.querySelector('#modal-content');
        this.modalButtons = document.querySelectorAll('[data-modal-target]');
        this.modalBackdrop = document.querySelector('.modal-content-backdrop');
        // Check if modal exists
        if (this.modal) {
            this.modalContentContainer = this.modal.querySelector('[data-modal-content-target]');
            this.closeButtons = this.modal.querySelectorAll('[data-modal-close]');
            this.init();
            this.closeEvent();
        }
    }
    init() {
        if (!this.modal)
            return;
        const self = this;
        this.modalButtons.forEach((button) => {
            let contentId = button.getAttribute('data-modal-target');
            let contentEL = document.querySelector('#' + contentId);
            let content = contentEL.innerHTML;
            button.addEventListener('click', function (e) {
                e.preventDefault();
                self.modalContentContainer.innerHTML = content;
                self.modal.classList.add('show');
            });
        });
    }
    closeEvent() {
        let self = this;
        this.closeButtons.forEach((button) => {
            button.addEventListener('click', function () {
                self.modalContentContainer.innerHTML = "";
                self.modal.classList.remove('show');
            });
        });
        document.addEventListener('keyup', function (e) {
            if (e.key === "Escape") { // escape key maps to keycode `27`
                self.modalContentContainer.innerHTML = "";
                self.modal.classList.remove('show');
            }
        });
    }
}
